import { RequestData } from '@/components/cards/request-data'
import { ViewStudentObservation } from '@/components/cards/view-student-observation'
import { HeaderActions } from '@/components/header-actions'
import { StudentLayout } from '@/components/layout/student'
import { Show } from '@/components/show'
import { CoursesEquivalences } from '@/components/tables/courses-quivalences'
import { REQUEST_STATUS } from '@/constants/request-status'
import { formatRequestProtocol } from '@/utils/format-request-protocol'
import { getRequestStatusById } from '@/utils/get-status-by-id'
import { useStudentMyReviews } from './hooks/use-student-my-reviews'

export const StudentMyReviews = () => {
  const {
    states: {
      isLoading,
      request,
      formMethods,
      grantStatus,
      showEquivalencesTable
    }
  } = useStudentMyReviews()

  const status = getRequestStatusById(request?.requestStatus?.id)
  const requestStatus = request?.requestStatus.id
  const showStatus =
    requestStatus !== REQUEST_STATUS.NOT_STARTED.id
    && requestStatus !== REQUEST_STATUS.UNDER_REVIEW.id

  return (
    <StudentLayout
      withLogoHeader={true}
      isLoading={isLoading}
      loadingTitle="Análise"
    >
      <HeaderActions
        requestTitle={`Análise #${formatRequestProtocol(request?.protocol)}`}
        linkHref={request?.previousEducation.academicTranscript}
        statusName={status?.student.name}
        statusColor={status?.student.color}
        titlePage="Suas análises"
        requestId={request?.id}
        buttonDisabled={!grantStatus}
      />

      <div className="flex flex-col gap-10 py-4">
        <RequestData
          ra={request?.student.ra}
          createdAt={request?.createdAt}
          name={request?.student.person.name}
          previousCourse={request?.previousEducation.name}
          desiredCourse={request?.desiredEducation.desiredEducation}
          status={status?.student.name}
        />

        <Show when={!!request?.observation}>
          <div>
            <ViewStudentObservation
              requestStatusId={request?.requestStatus.id}
              observation={request?.observation}
              withLabel={false}
            />
          </div>
        </Show>

        {showEquivalencesTable && (
          <CoursesEquivalences
            title="Disciplinas e Equivalências Selecionadas"
            onlyView={true}
            showCurriculumButton={false}
            showDisciplineButton={false}
            showStatusColumn={showStatus}
            formMethods={formMethods}
            showCurriculum={false}
          />
        )}
      </div>
    </StudentLayout>
  )
}
